import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NotificationService } from '@services/notification.service';
import { SessionStorageService } from '@services/storage.service';
import { dateOptions, notificationCenterItem, timeOptions } from '@shared/models/notificationcenter';

@Component({
	selector: 'app-notificationitem',
	templateUrl: './notificationitem.component.html',
	styleUrls: ['./notificationitem.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class NotificationitemComponent implements OnInit {
	@Input() public item: notificationCenterItem;
	@Input() public index: number;
	public formattedDate: string;
	public formattedTime: string;
	private locale: string = 'da-DK'; // We want the da-DK date format in all cases, as the EN does not look nice in the UI

	constructor(
		private sessionStorage: SessionStorageService,
		private notificationService: NotificationService,
	) {}

	ngOnInit(): void {
		this.formattedDate = new Intl.DateTimeFormat(this.locale, dateOptions).format(this.item.date).replace(/\./g, '/');
		this.formattedTime = new Intl.DateTimeFormat(this.locale, timeOptions).format(this.item.date).replace(/\./g, ':');
	}

	removeNotification(index) {
		this.notificationService.removeCenterNotification(index);
	}
}
